export const PROJECT_COORDINATE_SYSTEM = {
  // Underscore required because GLSL code expects COORDINATE_SYSTEM_LNG_LAT
  LNG_LAT: 1.0,

  // Previously known as LNGLAT_EXPERIMENTAL (in 6.0)
  LNGLAT_AUTO_OFFSET: 4.0,

  METER_OFFSETS: 2.0,
  LNGLAT_OFFSETS: 3.0,

  IDENTITY: 0.0
};
